<template>
    <div class="w-[100vw] h-[100vh]">
        <img :src="loginBg" class="h-full w-full cursor-pointer absolute" />

        <div class="h-full w-full flex flex-col absolute justify-center items-center gap-15">
            <img :src="loginLogo" class="w-3/4 cursor-pointer object-fit-contain" />

            <img :src="loginSub" class="md:w-1/2 md:p-0 w-full px-[1rem] object-cover cursor-pointer" />

            <Button
                size="large"
                label="Continue with Google"
                icon="pi pi-google !text-xl !leading-none"
                @click="goToAuth"
                class="md:w-[25vw] w-3/4 button_gradient !border-none"
            />
        </div>
    </div>
</template>
<script setup>
import Button from "primevue/button";
import { ref } from "vue";
import { useRouter } from "vue-router";
import loginBg from "@/assets/login_bg.jpeg";
import loginLogo from "@/assets/login_logo.png";
import loginSub from "@/assets/login_sub.png";
const checked = ref(true);
const router = useRouter();

const goToAuth = () => {
    window.location.href = process.env.VUE_APP_GOOGLE_AUTH_URL;
};

const goHome = () => {
    router.push({ path: "home" });
};
</script>

<style>
.button_gradient {
    background: linear-gradient(90deg, rgba(40, 112, 192, 1) 0%, rgba(14, 68, 140, 1) 100%) !important;
}
</style>
